import React from 'react';
import PropTypes from 'prop-types';
import EmployeeJobsTable from './employeeJobsTable';
const EmployeeJobs = _ref => {
  let _ref$jobs = _ref.jobs,
    jobs = _ref$jobs === void 0 ? [] : _ref$jobs;
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", {
    className: "t-eg-section-jobs"
  }, "Associations"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(EmployeeJobsTable, {
    jobs: jobs
  }));
};
EmployeeJobs.propTypes = {
  jobs: PropTypes.arrayOf(PropTypes.shape({}))
};
export default EmployeeJobs;